import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'lib-server-installation',
  imports: [CommonModule, RouterModule],
  templateUrl: './server-installation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServerInstallationComponent {}
